import React from 'react'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { PostHogConfig } from 'posthog-js'
import { PostHogProvider as PostHogProviderOrig } from 'posthog-js/react'

import { ConfirmProvider } from '@/components/confirmation.tsx'
import { queryClient } from '@/clients/query-client.ts'
import { ViewAttachmentsProvider } from '@/features/attachments/view-attachment.tsx'
import { AuthProvider } from '@/features/auth/auth-context.tsx'

const isProd = import.meta.env.VITE_ENV === 'prod'

export const Providers: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Sentry.ErrorBoundary>
      <PostHogProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <ConfirmProvider>
              <ViewAttachmentsProvider>{children}</ViewAttachmentsProvider>
            </ConfirmProvider>
          </QueryClientProvider>
        </AuthProvider>
      </PostHogProvider>
    </Sentry.ErrorBoundary>
  )
}

const posthogOptions: Partial<PostHogConfig> = {
  api_host: `${import.meta.env.VITE_API_BASE}/ingest`,
  ui_host: 'https://us.posthog.com',
}

function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!isProd) return children

  return (
    <PostHogProviderOrig
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={posthogOptions}
    >
      {children}
    </PostHogProviderOrig>
  )
}
